export default {
  TABLE_COLUMNS: [
    {
      key: 'orderId',
      displayName: 'Order ID',
      width: 1,
    },
    {
      key: 'transactionId',
      displayName: 'Transaction ID',
      width: 1,
    },
    {
      key: 'transactionAmount',
      displayName: 'Suspicious Amt.',
      width: 1.5,
      align: 'left',
    },
    {
      key: 'caseId',
      displayName: 'Case ID',
      width: 1,
    },
    // {
    //   key: 'settlementStatus',
    //   displayName: 'Settlement Status',
    //   width: 1,
    // },
    // {
    //   key: 'customerPhone',
    //   displayName: 'Phone No.',
    //   width: 0.14,
    // },
    // {
    //   key: 'paymentMode',
    //   displayName: 'Payment Method',
    //   width: 0.13,
    // },
    {
      key: 'riskStatus',
      displayName: 'Status',
      width: 1.6,
    },
    {
      key: 'suspiciousCta',
      displayName: '',
      width: 0.5,
    },
  ],
  FILTER_ITEMS: {
    status: {
      displayText: 'Case Status',
      type: 'CHECKBOX',
      items: {
        UNDER_REVIEW: 'Under Review',
        UPLOAD_EVIDENCE: 'Upload Proof',
        AGENT_REVIEW: 'Agent Review',
        CLOSED: 'Closed',
      },
    },
  },
  SEARCH_ITEMS: [
    {
      key: 'orderId',
      text: 'Order ID',
      value: 'orderId',
      placeholder: 'Ex: Order ID 1, Order ID 2',
      inputPattern: '^[\\|\\w\\d ,.-]+$',
      error: 'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
    },
    {
      key: 'transactionId',
      text: 'Transaction ID',
      value: 'transactionId',
      placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
      inputPattern: '^[0-9,]+$',
      error: 'Only numbers and comma are allowed.',
    },
    {
      key: 'phoneNumber',
      text: 'Phone Number',
      value: 'customerPhone',
      placeholder: 'Enter Phone Number',
      inputPattern: '^[0-9 +-]+$',
      maxLength: 14,
      error: 'Only numbers and special characters (space, plus, hyphen) are allowed.',
    },
    {
      key: 'riskCaseId',
      text: 'Case ID',
      value: 'caseId',
      placeholder: 'Enter Case ID',
      inputPattern: '^[0-9]+$',
      error: 'Only numbers are allowed.',
    },
    {
      key: 'email',
      text: 'Email ID',
      value: 'customerEmail',
      placeholder: 'Enter Email ID',
    },
  ],
};
